<template>
  <template v-if="activitiesForThisShift.length > 0">
    <rota-activity-card
      v-for="(activity, index) in activitiesForThisShift"
      :id="activity.id"
      :key="index"
      :activity="activity"
      :show-shifts="false"
      :show-end-time="true"
      :hide-start-day="true"
      class="mt-2"
      :style="getFlexboxOrderStyleFromTime(activity.startDate)"
    />
  </template>
</template>

<script>
import has from "lodash/has";
import RotaActivityCard from "@/components/activity/RotaActivityCard.vue";
import { getFlexboxOrderStyleFromTime } from "@/lib/date-functions";

export default {
  name: "RotaAgendaShiftActivities",
  components: {
    RotaActivityCard,
  },
  props: {
    activities: {
      type: [Boolean, Array],
      required: true,
    },
    shift: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  setup() {
    return {
      getFlexboxOrderStyleFromTime,
    };
  },
  computed: {
    activitiesForThisShift() {
      if (this.activities === false) {
        return [];
      }
      if (!has(this.shift, "activities")) {
        return [];
      }
      const activityIds = this.shift.activities.map(
        (activity) => activity.activityId,
      );
      const activities = this.activities.filter((activity) =>
        activityIds.includes(activity.id),
      );
      return activities.sort((a, b) => a.startDate - b.startDate);
    },
  },
};
</script>

<style scoped>
.card {
  --bs-card-spacer-x: 0.5em;
  --bs-card-spacer-y: 0.5em;
  overflow-x: hidden;
}
</style>
